import React, { useState } from 'react';

interface MfaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (code: string) => Promise<void>;
  isLoading: boolean;
}

export function MfaModal({ isOpen, onClose, onSubmit, isLoading }: MfaModalProps) {
  const [mfaCode, setMfaCode] = useState('');
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async () => {
    if (!mfaCode.trim()) {
      setError('Please enter the verification code');
      return;
    }

    try {
      await onSubmit(mfaCode);
      setMfaCode('');
      setError('');
    } catch (e: any) {
      setError(e.message || 'Verification failed. Please try again.');
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && mfaCode.trim() && !isLoading) {
      handleSubmit();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3 className="modal-title">🔐 Enter Verification Code</h3>
        <p className="modal-description">
          Check your email or authenticator app for the verification code from Garmin.
        </p>
        <input
          type="text"
          value={mfaCode}
          onChange={(e) => {
            setMfaCode(e.target.value);
            setError('');
          }}
          onKeyDown={handleKeyDown}
          placeholder="Enter 6-digit code"
          className="login-input"
          disabled={isLoading}
          autoFocus
        />
        {error && <div className="modal-error">{error}</div>}
        <div className="modal-actions">
          <button onClick={onClose} className="modal-button modal-button--secondary" disabled={isLoading}>
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="modal-button modal-button--primary"
            disabled={isLoading || !mfaCode.trim()}
          >
            {isLoading ? 'Verifying...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
}
